import api from '@/core/apiclient'
import { actionTypes } from '@/core/constants'

export default {
    async [actionTypes.DOCUMENTO.BUSCAR_TIPOS_DOCUMENTO]() {
        const { data } = await api.documento.buscarTiposDocumento()
        return data.items
    },

    async [actionTypes.DOCUMENTO.BUSCAR_DOCUMENTOS](_, params) {
        const { data } = await api.documento.buscarDocumentos(params)
        return data.items
    },

    async [actionTypes.DOCUMENTO.ENVIAR_DOCUMENTO](_, documento) {
        const formData = new FormData()
        const { arquivo, ...payload } = documento
        formData.append('file', arquivo)
        formData.append('inputStringData', JSON.stringify(payload))
        const { data } = await api.documento.enviarDocumento(formData)
        return data.uri
    },

    async [actionTypes.DOCUMENTO.DELETAR_DOCUMENTO](_, idDocumento) {
        const { data } = await api.documento.deletarDocumento(idDocumento)
        return data
    },

    async [actionTypes.DOCUMENTO.BAIXAR_DOCUMENTO](_, documento) {
        let response
        if (documento.idExterno === null) {
            response = await api.documento.downloadAnexo(documento.uriAnexo)
        } else {
            response = await api.documento.baixarDocumento(documento.id)
        }
        const blob = new Blob([response.data], {
            type: [
                'img/jpg',
                'img/jpeg',
                'img/png',
                'application/pdf',
                'application/xlsx',
            ],
        })
        const downloadLink = document.createElement('a')
        document.body.appendChild(downloadLink)
        downloadLink.setAttribute('type', 'hidden')
        downloadLink.href = window.URL.createObjectURL(blob)

        const filenameMatch = response.headers['content-disposition'].match(
            /filename="(.+?)"/
        )
        const regex = /\.[a-zA-Z0-9]+$/
        const val = regex.test(filenameMatch[1])

        downloadLink.download = val ? filenameMatch[1] : documento.uriAnexo
        downloadLink.click()
    },

    async [actionTypes.DOCUMENTO.BUSCAR_LICENCA_LACUNA_FLOWBEE]() {
        const {
            data,
        } = await api.documento.buscarLicencaLacunaFlowbeeDocumento()
        return data
    },

    async [actionTypes.DOCUMENTO.INICIAR_ASSINATURA_DIGITAL](
        _,
        { certificateContent, documentId }
    ) {
        const { data } = await api.documento.iniciarAssinaturaDigitalDocumento(
            documentId,
            certificateContent
        )
        return data
    },

    async [actionTypes.DOCUMENTO.FINALIZAR_ASSINATURA_DIGITAL](
        _,
        {
            documentId,
            signHash,
            temporarySubscription,
            rubricBase64,
            participation,
        }
    ) {
        const {
            data,
        } = await api.documento.finalizarAssinaturaDigitalDocumento(
            documentId,
            signHash,
            temporarySubscription,
            rubricBase64,
            participation
        )
        return data
    },


    async [actionTypes.DOCUMENTO.ASSINATURA_ELETRONICA](_, idExterno) {
        const {data} = await api.documento.assinarDocumentoEletronicamente(idExterno)
        return data
    },

    async [actionTypes.DOCUMENTO.BUSCAR_SIGNATARIOS](_, idExterno) {
        const {data} = await api.documento.buscarSignatariosDocumento(idExterno)
        return data
    },

    async [actionTypes.DOCUMENTO.CONVIDAR_SIGNATARIOS](_, {idExterno, signatarios}) {
        await api.documento.convidarSignatariosDocumento(idExterno, signatarios)
    },

    async [actionTypes.DOCUMENTO.REMOVER_SIGNATARIO](_, {idExterno, emailSignatario}) {
        await api.documento.removerSignatarioDocumento(idExterno, emailSignatario)
    },
}
